import { Nav } from "@rothoblaas/design-system";
import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../context/authContext";
import useI18n from "../hooks/useTranslations";
import { getAllowedAdminMenuEntries } from "./adminMenuEntries";
import Icon from "./ui/Icon";

type AdminMenuProps = {
  onClose: () => void;
};

const AdminMenu: FC<AdminMenuProps> = ({ onClose }) => {
  const i18n = useI18n();
  const auth = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  const entries = getAllowedAdminMenuEntries(auth.permissions);

  if (!entries.length) return undefined;

  return (
    <Nav onNavigate={navigate} currentPath={location.pathname}>
      <Nav.Group title={i18n.translation.common.administration}>
        {entries.map((entry) => (
          <Nav.Item
            key={entry.path}
            text={entry.getTitle(i18n.translation)}
            to={entry.path}
            icon={<Icon glyph={entry.icon} />}
            onClick={onClose}
          />
        ))}
      </Nav.Group>
    </Nav>
  );
};

export default AdminMenu;
